import { render, staticRenderFns } from "./EvaluationCommentDialog.vue?vue&type=template&id=fc1b40a0&scoped=true"
import script from "./EvaluationCommentDialog.vue?vue&type=script&lang=js"
export * from "./EvaluationCommentDialog.vue?vue&type=script&lang=js"
import style0 from "./EvaluationCommentDialog.vue?vue&type=style&index=0&id=fc1b40a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1b40a0",
  null
  
)

export default component.exports